import {Trans} from '@lingui/macro';
import React, {FC} from 'react';
import styled from 'styled-components';

import {Icon} from '../../../../libs/shared/ui/src/components/icon/icon';
import {fontSizes, fontWeights} from '../../../../libs/shared/ui/src/styles/fontStyles';
import {useUserTheme} from '../../../../libs/shared/ui/src/theme/userThemeProvider';

/*
 * Styles.
 */

const StyledMergeNoConflictsBannerContainerDiv = styled.div`
  display: flex;
  flex-flow: row;
  background: ${(p) => p.theme.palette.green.shade20};
  border-radius: 16px;
  margin: 12px -8px;
  padding: 9px 10px;

  &:not(:first-child) {
    margin-top: 8px;
  }
`;

const StyledIcon = styled(Icon)`
  margin-right: 8px;
`;

const StyledNoConflictsTextContainerDiv = styled.div`
  flex: 1;
  font-size: ${fontSizes.verySmall};
  line-height: ${fontSizes.large};
  font-weight: ${fontWeights.medium};
`;

/*
 * Component.
 */

export const ContactMergeNoConflictsBanner: FC = () => {
  const theme = useUserTheme();

  return (
    <StyledMergeNoConflictsBannerContainerDiv>
      <StyledIcon name="checkmarkCircleSmall" color={theme.palette.green.shade40} />
      <StyledNoConflictsTextContainerDiv>
        <Trans id="contact-details-merge-banner-no-conflicting-properties">No conflicting properties</Trans>
      </StyledNoConflictsTextContainerDiv>
    </StyledMergeNoConflictsBannerContainerDiv>
  );
};
